(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["findlay-wiggles-builder"] && !Shopify.designMode) return;
  try {
    

function initFindlayWigglesBuilder(builder) {
  if (!builder) {
    return;
  }

  if (builder.dataset.f3dReady === 'true') {
    return;
  }

  builder.dataset.f3dReady = 'true';

  const buttons =
    builder.querySelectorAll('[data-f3d-add]');

    const categoryButtons =
  builder.querySelectorAll(
    '[data-f3d-category]'
  );

const productCards =
  builder.querySelectorAll(
    '[data-f3d-product-tags]'
  );

  const emptyMessage = builder.querySelector('[data-f3d-empty]');

  const countDisplay =
    builder.querySelector('[data-f3d-count]');

  const savingsDisplay =
    builder.querySelector('[data-f3d-savings]');

  const progressBar =
    builder.querySelector('[data-f3d-progress]');

  const messageDisplay =
    builder.querySelector('[data-f3d-message]');

  const summary =
    builder.querySelector('[data-f3d-summary]');

  const summaryItems =
    builder.querySelector('[data-f3d-items]');

     const cartButton = builder.querySelector('[data-f3d-add-to-cart]');
  const cartError = builder.querySelector('[data-f3d-cart-error]');

  const STORAGE_KEY = 'findlay3d_wiggle_bag_v2';

const bag = [];

function loadBag() {
bag.length = 0;

  try {
    const savedBag =
      window.localStorage.getItem(STORAGE_KEY);

    if (!savedBag) {
      return;
    }

    const parsedBag =
      JSON.parse(savedBag);

    if (!Array.isArray(parsedBag)) {
      return;
    }

        parsedBag.forEach(function(item) {
      if (
        item &&
        item.variantId &&
        item.productTitle
      ) {
        bag.push({
          variantId: String(item.variantId),
          productTitle: String(item.productTitle),
          variantTitle: item.variantTitle
            ? String(item.variantTitle)
            : '',
          type: item.type === 'keychain' ||
            String(item.variantTitle || '').toLowerCase().indexOf('keychain') !== -1
            ? 'keychain'
            : 'wiggle'
        });
      }
    });
  } catch (error) {
    console.warn(
      'Findlay Wiggles: Could not restore saved bag.',
      error
    );
  }
}


function saveBag() {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(bag)
    );
  } catch (error) {
    console.warn(
      'Findlay Wiggles: Could not save bag.',
      error
    );
  }
}


  function getGroupedBag() {
    const grouped = {};

    bag.forEach(function(item) {
      const key = item.variantId;

      if (!grouped[key]) {
        grouped[key] = {
          variantId: item.variantId,
          title: item.productTitle,
          variant: item.variantTitle,
          type: item.type,
          quantity: 0
        };
      }

      grouped[key].quantity += 1;
    });

    return grouped;
  }


  function addItemByVariant(variantId) {
  const existingItem =
    bag.find(function(item) {
      return item.variantId === variantId;
    });

  if (!existingItem) {
    return;
  }

    bag.push({
    variantId: existingItem.variantId,
    productTitle: existingItem.productTitle,
    variantTitle: existingItem.variantTitle,
    type: existingItem.type
  });

  saveBag();
  updateBag();
}


function removeItemByVariant(variantId) {
  for (let i = bag.length - 1; i >= 0; i -= 1) {
    if (bag[i].variantId === variantId) {
      bag.splice(i, 1);
      break;
    }
  }

  saveBag();
  updateBag();
}


  function createQuantityButton(symbol, label, variantId, action) {
    const button =
      document.createElement('button');

    button.type = 'button';
    button.className =
      'f3d-summary-qty-button';

    button.textContent = symbol;
    button.setAttribute('aria-label', label);

    button.addEventListener('click', function() {
      if (action === 'add') {
        addItemByVariant(variantId);
      }

      if (action === 'remove') {
        removeItemByVariant(variantId);
      }
    });

    return button;
  }


  function updateSummary() {
    if (!summary || !summaryItems) {
      return;
    }

    summaryItems.innerHTML = '';

    if (bag.length === 0) {
      summary.hidden = true;
      return;
    }

    summary.hidden = false;

    const grouped =
      getGroupedBag();

    Object.keys(grouped).forEach(function(key) {
      const item =
        grouped[key];

      const chip =
        document.createElement('div');

            chip.className =
        'f3d-summary-chip' +
        (item.type === 'keychain' ? ' f3d-summary-chip-keychain' : '');


      const label =
        document.createElement('span');

      label.className =
        'f3d-summary-chip-label';

      let labelText =
        item.title;

      if (item.variant) {
        labelText +=
          ' - ' + item.variant;
      }

      label.textContent =
        labelText;


      const controls =
        document.createElement('span');

      controls.className =
        'f3d-summary-qty-controls';


      const minusButton =
        createQuantityButton(
          '−',
          'Remove one ' + labelText,
          item.variantId,
          'remove'
        );


      const quantity =
        document.createElement('span');

      quantity.className =
        'f3d-summary-quantity';

      quantity.textContent =
        item.quantity;

      quantity.setAttribute(
        'aria-label',
        item.quantity + ' selected'
      );


      const plusButton =
        createQuantityButton(
          '+',
          'Add one ' + labelText,
          item.variantId,
          'add'
        );


      controls.appendChild(minusButton);
      controls.appendChild(quantity);
      controls.appendChild(plusButton);

      chip.appendChild(label);
      chip.appendChild(controls);

      summaryItems.appendChild(chip);
    });
  }


    function updateBag() {
        const count =
      bag.filter(function(item) {
        return item.type !== 'keychain';
      }).length;

    const keychainCount =
      bag.length - count;

    if (countDisplay) {
      let countText =
        count === 1
          ? '1 Wiggle selected'
          : count + ' Wiggles selected';

      if (keychainCount > 0) {
        countText +=
          ' + ' +
          keychainCount +
          (keychainCount === 1 ? ' Keychain' : ' Keychains');
      }

      countDisplay.textContent = countText;
    }


    if (progressBar) {
  const progress = Math.min((count / 24) * 100, 100);

  progressBar.style.setProperty(
    'width',
    progress + '%',
    'important'
  );
}


    if (savingsDisplay) {
      savingsDisplay.classList.remove(
        'unlocked'
      );
    }


    if (count === 0) {
      if (savingsDisplay) {
        savingsDisplay.textContent =
          'START PICKING!';
      }

      if (messageDisplay) {
        messageDisplay.textContent =
          'Pick your first Wiggle and start building your bundle!';
      }
    }


    else if (count < 6) {
      const needed =
        6 - count;

      if (savingsDisplay) {
        savingsDisplay.textContent =
          'BUILDING YOUR BUNDLE';
      }

      if (messageDisplay) {
        messageDisplay.textContent =
          'Add ' +
          needed +
          (needed === 1
            ? ' more Wiggle'
            : ' more Wiggles') +
          ' to unlock 17% OFF!';
      }
    }


    else if (count < 12) {
      const needed =
        12 - count;

      if (savingsDisplay) {
        savingsDisplay.textContent =
          '17% OFF UNLOCKED';

        savingsDisplay.classList.add(
          'unlocked'
        );
      }

      if (messageDisplay) {
        messageDisplay.textContent =
          'Nice! Add ' +
          needed +
          (needed === 1
            ? ' more Wiggle'
            : ' more Wiggles') +
          ' to unlock 25% OFF.';
      }
    }


    else if (count < 24) {
      const needed =
        24 - count;

      if (savingsDisplay) {
        savingsDisplay.textContent =
          '25% OFF UNLOCKED';

        savingsDisplay.classList.add(
          'unlocked'
        );
      }

      if (messageDisplay) {
        messageDisplay.textContent =
          'Great bundle! Add ' +
          needed +
          (needed === 1
            ? ' more Wiggle'
            : ' more Wiggles') +
          ' to unlock our BEST VALUE: 33% OFF.';
      }
    }


    else {
      if (savingsDisplay) {
        savingsDisplay.textContent =
          '33% OFF UNLOCKED';

        savingsDisplay.classList.add(
          'unlocked'
        );
      }

      if (messageDisplay) {
        messageDisplay.textContent =
          'BEST VALUE unlocked! Keep adding your favorites.';
      }
    }
if (cartButton) {
            cartButton.disabled = bag.length === 0;
    }
    updateSummary();

  }


  function showAddedState(button) {
    button.classList.add(
      'f3d-added'
    );

    window.setTimeout(function() {
      button.classList.remove(
        'f3d-added'
      );
    }, 700);
  }


  function addWiggle(button) {
    if (!button || button.disabled) {
      return;
    }

    const variantId =
      button.dataset.variantId || '';

    const productTitle =
      button.dataset.productTitle ||
      'Wiggle';

    const variantTitle =
      button.dataset.variantTitle ||
      '';

    if (!variantId) {
      return;
    }

        bag.push({
      variantId: variantId,
      productTitle: productTitle,
      variantTitle: variantTitle,
      type: button.dataset.f3dType === 'keychain' ? 'keychain' : 'wiggle'
    });

saveBag();

showAddedState(button);

updateBag();
  }

  function addBagToCart() {
    if (bag.length === 0 || !cartButton) {
      return;
    }

    const grouped = getGroupedBag();

    const payload = {
      items: Object.keys(grouped).map(function(key) {
        return {
          id: Number(grouped[key].variantId),
          quantity: grouped[key].quantity,
                  properties: { _bundle: grouped[key].type === 'keychain' ? 'keychain' : 'wiggles' }
        };
      })
    };

    const drawer = document.querySelector('cart-drawer');

    if (drawer) {
      payload.sections = drawer.getSectionsToRender().map(function(section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    }

    cartError.hidden = true;
    cartButton.disabled = true;
    cartButton.textContent = 'ADDING...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function(result) {
        if (!result.ok) {
          throw new Error(
            result.data.description ||
            result.data.message ||
            'Something went wrong adding your Wiggles.'
          );
        }

        bag.length = 0;
        saveBag();
        updateBag();

        if (drawer && result.data.sections) {
          result.data.id = result.data.items[0].id;
          drawer.renderContents(result.data);
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function(error) {
        cartError.textContent = error.message;
        cartError.hidden = false;
      })
      .finally(function() {
        cartButton.textContent = 'ADD BUNDLE TO CART';
        cartButton.disabled = bag.length === 0;
      });
  }

  if (cartButton) {
    cartButton.addEventListener('click', addBagToCart);
  }

  buttons.forEach(function(button) {
    button.addEventListener(
      'click',
      function() {
        addWiggle(button);
      }
    );
  });

function filterProducts(category) {
  let visibleCount = 0;

  productCards.forEach(function(card) {
    const tags =
      (card.dataset.f3dProductTags || '')
        .split(',')
        .map(function(tag) {
          return tag.trim().toLowerCase();
        });

    const shouldShow =
      category === 'all' ||
      tags.includes(category.toLowerCase());

    card.hidden = !shouldShow;

    if (shouldShow) {
      visibleCount += 1;
    }
  });

  if (emptyMessage) {
    emptyMessage.hidden = visibleCount > 0;
  }

  categoryButtons.forEach(function(button) {
    const isActive =
      button.dataset.f3dCategory === category;

    button.classList.toggle(
      'active',
      isActive
    );
  });
}


categoryButtons.forEach(function(button) {
  button.addEventListener(
    'click',
    function() {
      const category =
        button.dataset.f3dCategory;

      filterProducts(category);
    }
  );
});


filterProducts('all');

  loadBag();
updateBag();
}


function initAllFindlayWigglesBuilders(scope) {
  const root =
    scope || document;

  const builders =
    root.querySelectorAll(
      '[data-f3d-builder]'
    );

  builders.forEach(function(builder) {
    initFindlayWigglesBuilder(builder);
  });
}


if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    function() {
      initAllFindlayWigglesBuilders(
        document
      );
    }
  );
} else {
  initAllFindlayWigglesBuilders(
    document
  );
}


document.addEventListener(
  'shopify:section:load',
  function(event) {
    initAllFindlayWigglesBuilders(
      event.target
    );
  }
);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
